import { NavigateFunction } from "react-router-dom";

import { OrganisationTypeConstants } from "../../../constants";
import { getCollaboratorRoute } from "../../../utils/routes";
import { ButtonLinkCellFormatterData } from "../../../widget/data/DataGrid/models";

/*
  BR-02833: an issuance transaction's counterparty/broker company name is always shown, but the API only
  returns the company `uuid` to organisations holding MANAGE_COLLABORATOR on it. A null uuid therefore means
  "no CRM record this viewer may open" - render the name as plain text and make no collaborator lookup.
  `buttonLink` renders a bare span when the cell carries no action, so one cell shape covers both cases.
*/
export const buildCompanyCell = (
  company: { name: string | null; uuid: string | null } | null,
  userType: OrganisationTypeConstants | undefined,
  navigate: NavigateFunction
): ButtonLinkCellFormatterData =>
  ({
    text: company?.name ?? "",
    action:
      company?.uuid && userType ? () => navigate(getCollaboratorRoute(company.uuid as string, userType)) : undefined,
  }) as ButtonLinkCellFormatterData;
